import merge from 'deepmerge'
import {
  newFromPayload,
  compressAndFilter,
  compactAndFilter,
  mergeIds,
  sortData,
  getParams,
  filterItems,
  smartFilter,
} from '@/utils'
import router from '@/router'

export default (module, apiClient, initialDoc) => (
  {
    namespaced: true,
    state: {
      ui: {
        selector: 0,
        listView: 'card',
        singleView: 'card',
      },
      loading: false,

      // Set defaut configs here
      doc: merge({
        list: {
          name: 'Placeholder (plural)',
          headers: [],
          actions: [
          ],
          selectActions: [
            {
              label: 'Exporter en PDF',
              icon: 'fas fa-file-pdf',
              isFlat: true,
              dispatch: `${module}/export`,
              context: {format: 'pdf'},
              menu: true,
            },
            {
              label: 'Exporter en Excel',
              icon: 'fas fa-file-excel',
              isFlat: true,
              dispatch: `${module}/export`,
              context: {format: 'xls'},
              menu: true,
            },
          ],
          search: [],
          adhoc: {},
        },
        form: {
          name: 'Placeholder (singular)',
          hasPhoto: false,
          fields: [],
          actions: [],
          relations: [],
          adhoc: {},
        },
        params: {
          fetchAll: {},
          fetchOne: {},
        },
      }, initialDoc),

      // List data
      list: {
        pagination: {
          sortBy: '',
          descending: true,
          page: 1,
          rowsPerPage: 12,
        },
        quickSearch: '',
        selectedItems: [],
        items: [],
        hasError: false,
        errors: {},
        showAlert: false,
      },
      // Search data
      search: {
        dialog: false,
        data: {},
      },
      // Form data
      form: {
        dialog: false,
        data: {},
        hasError: false,
        errors: {},
        saved: false,
        showAlert: false,
        edit: false,
        currentRelation: null,
      },
    },
    getters: {
      selectedItems: state => state.list.selectedItems,
      quickSearch: state => state.list.quickSearch,
      unfiltered: state => state.list.items,
      smartFiltered: state => smartFilter(state.list.quickSearch, state.list.items, state.doc.list.headers),
      items: (state, getters) => sortData(getters.smartFiltered, state.list.pagination),
      totalCount: (state, getters) => getters.smartFiltered.length,
      pagination: state => state.list.pagination,
      doc: state => state.doc,
      list: state => state.list,
      form: state => state.form,
      search: state => state.search,
      isLoading: state => state.loading,
      listView: state => state.ui.listView,
      singleView: state => state.ui.singleView,
      selects: state => state.selects,
      currentRelation: state => state.form.currentRelation,
    },
    mutations: {
      SET_LOADING (state, payload) {
        state.loading = payload
      },
      SET_LIST_VIEW (state, selector) {
        state.ui.listView = selector
      },
      SET_QUICK_SEARCH (state, payload) {
        state.list.quickSearch = payload
      },
      SET_CURRENT_RELATION (state, payload) {
        state.form.currentRelation = payload
      },
      SET_SINGLE_VIEW (state, selector) {
        switch (selector) {
          case 'edit':
            state.form.edit = true
            break
          default:
            state.form.edit = false
            break
        }
        state.ui.singleView = selector
      },
      UPDATE_SELECTION: (state, payload) => {
        state.list.selectedItems = payload
      },
      UPDATE_SORT: (state, payload) => {
        if (state.list.pagination.sortBy === payload) {
          state.list.pagination.descending = !state.list.pagination.descending
        } else {
          state.list.pagination.sortBy = payload
        }
      },
      UPDATE_PAGINATION: (state, payload) => {
        state.list.pagination = {...payload}
      },
      SELECT_ALL: (state) => {
        state.list.selectedItems = state.list.items
      },
      SELECT_NONE: (state) => {
        state.list.selectedItems = []
      },
      LIST_REQUEST: (state, payload) => {
      },
      LIST_SUCCESS: (state, payload) => {
        const postprocess = state.doc.postprocess ? state.doc.postprocess : item => item
        state.list.items = payload.map(postprocess)
        state.list.selectedItems = []
        state.list.hasError = false
        state.list.showAlert = false
        state.list.quickSearch = null
      },
      LIST_NOT_MODIFIED: (state, payload) => {
      },
      LIST_ERROR: (state, payload) => {
        const { errors } = payload
        const postprocess = state.doc.postprocess ? state.doc.postprocess : item => item
        state.list.items = errors ? errors.map(postprocess) : []
        state.list.showAlert = true
        state.list.hasError = true
        state.list.errors = payload
        state.list.selectedItems = []
      },
      GET_REQUEST: (state, payload) => {
        state.form.hasError = false
        state.form.edit = false
        state.form.data = {}
      },
      GET_SUCCESS: (state, payload) => {
        const postprocess = state.doc.postprocess ? state.doc.postprocess : item => item
        state.form.data = postprocess(payload)
        state.form.saved = false
      },
      GET_NOT_MODIFIED: (state, payload) => {
      },
      GET_ERROR: (state, payload) => {
        state.form.errors = payload
        state.form.hasError = true
      },
      POST_REQUEST: (state, payload) => {
        state.form.showAlert = false
      },
      POST_SUCCESS: (state, payload) => {
        state.form.saved = true
        state.form.errors = {}
        state.form.hasError = false
      },
      POST_ERROR: (state, payload) => {
        state.form.errors = payload
        state.form.hasError = true
        state.form.showAlert = true
      },
      UPDATE_REQUEST: (state, payload) => {
        state.loading = true
        state.form.showAlert = false
      },
      UPDATE_SUCCESS: (state, payload) => {
        const postprocess = state.doc.postprocess ? state.doc.postprocess : item => item
        state.form.data = postprocess(payload)
        state.list.items = state.list.items.map(item => item.id === payload.id ? postprocess(payload) : item)
        state.form.saved = true
        state.form.hasError = false
        state.form.errors = {}
        state.form.showAlert = true
      },
      UPDATE_ERROR: (state, payload) => {
        state.form.errors = payload
        state.form.saved = false
        state.form.hasError = true
        state.form.showAlert = true
      },
      DELETE_REQUEST: (state, payload) => {
      },
      DELETE_SUCCESS: (state, payload) => {
        state.list.showAlert = false
        state.list.items = filterItems(state.list.items, payload)
      },
      DELETE_ERROR: (state, payload) => {
        state.form.errors = payload
        state.list.errors = payload
        state.form.hasError = true
        state.list.hasError = true
        state.list.showAlert = true
      },
      RESET_FORM: (state, payload) => {
        state.form.data = {}
        state.form.errors = []
        state.form.hasError = false
        state.form.saved = false
      },
      OPEN_FORM: (state, payload) => {
        state.form.dialog = true
      },
      CLOSE_FORM: (state, payload) => {
        state.form.dialog = false
      },
      HIDE_FORM_ALERT: (state) => {
        state.form.showAlert = false
      },
      HIDE_LIST_ALERT: (state) => {
        state.list.showAlert = false
      },
      UPDATE_FORM_FIELD: (state, payload) => {
        state.form.data = newFromPayload(state.form.data, payload)
      },
      OPEN_SEARCH: (state, payload) => {
        state.search.dialog = true
      },
      RESET_SEARCH: (state, payload) => {
        state.search.data = {}
      },
      CLOSE_SEARCH: (state, payload) => {
        state.search.dialog = false
      },
      UPDATE_SEARCH_FIELD: (state, payload) => {
        state.search.data = newFromPayload(state.search.data, payload)
      },
      EXPORT_REQUEST: (state, payload) => {
        // console.log(payload)
        state.loading = true
      },
      EXPORT_PROGRESS: (state, payload) => {
        // console.log(payload)
      },
      EXPORT_SUCCESS: (state, payload) => {
        state.loading = false
        const {filename, blob} = payload
        const url = window.URL.createObjectURL(blob)
        // window.open(url)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
      },
      EXPORT_ERROR: (state, payload) => {
        state.loading = false
      },
    },
    actions: {
      smartSearch: ({ commit, state }, payload) => {
        let pagination = {...state.list.pagination, page: 1}
        commit('UPDATE_PAGINATION', pagination)
        commit('SET_QUICK_SEARCH', payload)
      },
      setListView: ({ commit }, payload) => {
        commit('SET_LIST_VIEW', payload.data)
      },
      setCurrentRelation: ({ commit }, payload) => {
        commit('SET_CURRENT_RELATION', payload.data)
      },
      setSingleView: ({ commit }, payload) => {
        commit('SET_SINGLE_VIEW', payload.data)
      },
      updateSelected: ({ commit }, payload) => {
        commit('UPDATE_SELECTION', payload.data)
      },
      updateSort: ({ commit }, payload) => {
        commit('UPDATE_SORT', payload.data)
      },
      updatePagination: ({ commit }, payload) => {
        commit('UPDATE_PAGINATION', payload.data)
      },
      selectAll: ({ commit }, payload) => {
        commit('SELECT_ALL')
      },
      selectNone: ({ commit }, payload) => {
        commit('SELECT_NONE')
      },
      fetchAll: ({ commit }, payload) => {
        const { data, context } = payload
        commit('LIST_REQUEST', payload)
        commit('SET_LOADING', true)
        // console.log('search', data)
        let compacted = compactAndFilter(data)
        // console.log('compacted', compacted)
        let params = getParams(context)
        // console.log('params', params)
        apiClient.fetchAll(module, {...params, ...compacted})
          .then(data => {
            commit('LIST_SUCCESS', data)
            commit('SET_LOADING', false)
          })
          .catch(error => {
            commit('LIST_ERROR', error)
            commit('SET_LOADING', false)
          })
      },
      fetchOne: ({ commit, dispatch, state }, payload) => {
        commit('SET_LOADING', true)
        const {data, context} = payload
        commit('GET_REQUEST', payload)
        apiClient.fetchOne(module, data, getParams(context))
          .then(data => {
            commit('GET_SUCCESS', data)
            commit('SET_LOADING', false)
          })
          .catch(error => {
            // console.log(error)
            commit('GET_ERROR', error)
            commit('SET_LOADING', false)
          })
      },
      create: ({ commit, dispatch }, payload) => {
        commit('SET_LOADING', true)
        commit('POST_REQUEST', payload)
        let cleaned = compressAndFilter(payload.data)
        apiClient.create(module, cleaned)
          .then(data => {
            commit('POST_SUCCESS', data)
            commit('CLOSE_FORM', data)
            commit('SET_LOADING', false)
            dispatch('goTo', {accessors: {}, context: {}, data})
          })
          .catch(error => {
            commit('POST_ERROR', error)
            commit('SET_LOADING', false)
          })
      },
      update: ({ commit }, payload) => {
        commit('SET_LOADING', true)
        commit('UPDATE_REQUEST', payload)
        const { data, context } = payload
        let cleaned = compressAndFilter(data)
        apiClient.update(module, context.id, cleaned, context.params)
          .then(response => {
            commit('UPDATE_SUCCESS', response)
            commit('SET_LOADING', false)
          })
          .catch(error => {
            commit('UPDATE_ERROR', error)
            commit('SET_LOADING', false)
          })
      },
      delete: ({ commit, dispatch }, payload) => {
        commit('SET_LOADING', true)
        commit('DELETE_REQUEST', payload)
        const { data } = payload
        apiClient.delete(module, data.id)
          .then(response => {
            commit('DELETE_SUCCESS', data.id)
            commit('SET_LOADING', false)
            dispatch('goToList', {})
          })
          .catch(error => {
            commit('DELETE_ERROR', error)
            commit('SET_LOADING', false)
          })
      },
      openForm: ({ commit }, payload) => {
        commit('RESET_FORM')
        commit('OPEN_FORM')
      },
      closeForm: ({ commit }, payload) => {
        commit('CLOSE_FORM')
        commit('RESET_FORM')
      },
      hideFormAlert: ({ commit }, payload) => {
        commit('HIDE_FORM_ALERT')
      },
      hideListAlert: ({ commit }, payload) => {
        commit('HIDE_LIST_ALERT')
      },
      editForm: ({ commit }, payload) => {
        commit('EDIT_FORM', payload)
      },
      updateFormField: ({ commit }, payload) => {
        commit('UPDATE_FORM_FIELD', payload.data)
      },
      openSearch: ({ commit }, payload) => {
        commit('OPEN_SEARCH')
      },
      openRelatedSearch: ({ commit, dispatch, state }, payload) => {
        dispatch(`${state.form.currentRelation}/openSearch`, {}, {root: true})
      },
      closeSearch: ({ commit }, payload) => {
        commit('CLOSE_SEARCH')
      },
      resetSearch: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
          commit('RESET_SEARCH')
          resolve(true)
        })
      },
      updateSearchField: ({ commit }, payload) => {
        commit('UPDATE_SEARCH_FIELD', payload.data)
      },
      export: ({ commit }, payload) => {
        commit('SET_LOADING', true)
        const { accessors, context, data } = payload
        commit('EXPORT_REQUEST', payload)
        const callBack = event => { commit('EXPORT_PROGRESS', event) }
        let filters = {id: mergeIds(data)}
        let params = {format: context.format, ...context.params, ...filters}
        delete params.include
        apiClient.exportTable(module, accessors, params, callBack)
          .then(response => {
            commit('EXPORT_SUCCESS', response)
            commit('SELECT_NONE')
            commit('SET_LOADING', false)
          })
          .catch(error => {
            commit('EXPORT_ERROR', error)
            commit('SET_LOADING', false)
          })
      },
      batchDelete: ({ commit }, payload) => {
        commit('SET_LOADING', true)
        const { context, data } = payload
        commit('DELETE_REQUEST', payload)
        let filters = {id: mergeIds(data)}
        let params = {...context.params, ...filters}
        // console.log(params)
        apiClient.batchDelete(module, params)
          .then(response => {
            commit('DELETE_SUCCESS', data)
            commit('SELECT_NONE')
            commit('SET_LOADING', false)
          })
          .catch(error => {
            commit('DELETE_ERROR', error)
            commit('SET_LOADING', false)
          })
      },
      goToList: ({ commit }, payload) => {
        let query = payload.query || {}
        router.push({ name: module, query })
      },

      goTo: ({ commit }, payload) => {
        // console.log('goTo', payload)
        router.push({name: `${module}Single`, params: {id: payload.data.id}})
      },

      // placeholders
      useSelection: ({ commit }, payload) => {
        console.log(payload)
      },
      deleteBatch: ({ commit }, payload) => {
        console.log(payload)
      },
    },
  }
)
